module.exports = __webpack_public_path__ + "static/media/gi.71cfe39b.svg";